import { ValidatorFn, Validators } from '@angular/forms';

const WHOLE_NUMBER = Validators.pattern('^(0|[1-9][0-9]*)$');

// Wbudowane min/max przepuszczają pustą wartość (ValidateService.minValue nie), więc pola zostają opcjonalne.
// Pattern przed min: ValidateErrorsComponent pokazuje pierwszy błąd, a tekst ma dostać komunikat o formacie.
export const WEIGHT_KG_VALIDATORS: ValidatorFn[] = [WHOLE_NUMBER, Validators.min(1), Validators.max(700)];
export const HEIGHT_CM_VALIDATORS: ValidatorFn[] = [WHOLE_NUMBER, Validators.min(30), Validators.max(270)];
